(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/analytics-promotion/assets/javascripts/promoimpression.js') >= 0) return;  svs.modules.push('/components/components/analytics-promotion/assets/javascripts/promoimpression.js');
"use strict";


svs.components = svs.components || {};
svs.components.analytics = svs.components.analytics || {};
svs.components.analytics.trackPromoImpression = svs.components.analytics.trackPromoImpression || {};
svs.core = svs.core || {};
svs.core.analytics = svs.core.analytics || {};
svs.core.analytics.adl = svs.core.analytics.adl || {};
const msg = new svs.core.log.Message(svs.core.log.MessageType.event);
svs.components.analytics.trackPromoImpression = function (evt) {
  const promoElement = {
    componentType: 'promo',
    componentID: evt.id,
    componentName: evt.name,
    componentPosition: evt.position
  };
  const data = {
    event: 'promoImpression',
    component: [promoElement]
  };
  if (evt && evt.opt_label) {
    data.eventInfo = {
      eventName: evt.opt_label
    };
  }
  window.dataLayerPush(data);
  window.adobeDataLayer.adlPush('promoView', {
    site: svs.core.analytics.adl.site,
    consent: svs.core.analytics.adl.consent,
    user: svs.core.analytics.adl.user,
    page: svs.core.analytics.adl.page,
    category: promoElement.componentID,
    action: promoElement.componentName,
    label: promoElement.componentPosition,
    value: ''
  });

  msg.eventCategory = 'Impression';
  msg.eventAction = "[".concat(promoElement.componentPosition, "]");
  msg.eventLabel = promoElement.componentName;
  msg.eventValue = 1;
  svs.core.log.track('svs.components.analytics', msg);
};

 })(window);